module.exports = __webpack_public_path__ + "db5ae58a97cf1736b89885579ac81421.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icons/angellist-icon.svg
 ** module id = 206
 ** module chunks = 0
 **/